import { useState, useCallback } from "react";

export default function useShowPassword() {
  const [showPassword, setShowpassword] = useState(false);
  const toggleShowPassword = useCallback(() => {
    setShowpassword((value) => !value);
  }, [setShowpassword]);
  return { showPassword, toggleShowPassword };
}
